import type { DefaultError } from '@atlassian/help-center-common-util/errors';

export const LOGIN_CONSENT = 'state.ui.LOGIN_CONSENT';
export const LOGIN_CONSENT_FAILURE = 'state.ui.LOGIN_CONSENT_FAILURE';
export const LOGIN_CONSENT_SUCCESS = 'state.ui.LOGIN_CONSENT_SUCCESS';

export interface LoginConsentAction {
    payload: {
        param: string;
    };
    type: typeof LOGIN_CONSENT;
}

export const loginConsentAction = (param: string): LoginConsentAction => {
    return {
        payload: {
            param,
        },
        type: LOGIN_CONSENT,
    };
};

export interface LoginConsentFailure {
    payload: {
        error: DefaultError;
    };
    type: typeof LOGIN_CONSENT_FAILURE;
}

export const loginConsentFailure = (error: DefaultError): LoginConsentFailure => ({
    payload: {
        error,
    },
    type: LOGIN_CONSENT_FAILURE,
});

export interface LoginConsentSuccess {
    payload: LoginConsentSuccessPayload;
    type: typeof LOGIN_CONSENT_SUCCESS;
}

export interface LoginConsentSuccessPayload {
    uri: string;
}
export const loginConsentSuccess = (payload: LoginConsentSuccessPayload): LoginConsentSuccess => {
    return {
        payload: {
            uri: payload?.uri,
        },
        type: LOGIN_CONSENT_SUCCESS,
    };
};
